import { Module } from "wrapper6";
import $ from "jquery";
import debounce from "debounce";

export default class ClickGallery extends Module {
    ready() {

        let IMGS = '.click-img';
        let RIGHT = '.arrow.right';
        let LEFT = '.arrow.left';
        let POPUP = '#popup';
        let CURNUM = 0;
        let ACTIVE = false;
        let MAX = $('.click-img').length - 1;

        $(document).on('click', IMGS, function(){
            CURNUM = $(this).data('img');
            ACTIVE = true;
            $(POPUP+' .block.active img').attr('src', $(this).attr('src'));

            console.log($(this).attr('src'));

            let curblock = $(POPUP+' .block.active');

            $(curblock).data('num', $(this).data('img'));
            let leftElem = $('*[data-img="'+($(this).data('img') - 1)+'"]');
            let rightElem = $('*[data-img="'+($(this).data('img') + 1)+'"]');


            if(!rightElem.length) {
                $(RIGHT).addClass('noclick');
            } else {
                $(RIGHT).removeClass('noclick');
                $('<div class="block post" data-num="'+($(this).data('img') + 1)+'"><img src="'+$(rightElem).attr('src')+'"/></div>').insertAfter($(curblock));
            }


            if(!leftElem.length){
                $(LEFT).addClass('noclick');
            } else {
                $(LEFT).removeClass('noclick');
                $('<div class="block pre" data-num="'+($(this).data('img') - 1)+'"><img src="'+$(leftElem).attr('src')+'"/></div>').insertBefore($(curblock));
            }

            $(POPUP).css('display', 'flex');
            setTimeout(()=> {
                $(POPUP).css('opacity', '1');
            }, 100)
        });

        document.onkeydown = (e) => {
            if(ACTIVE) {
                console.log(parseInt(e.keyCode));
                switch (parseInt(e.keyCode)) {
                    case 37:
                        CURNUM = this.goLeft(RIGHT, CURNUM, LEFT);
                        break;
                    case 39:
                        CURNUM = this.goRight(RIGHT, CURNUM, LEFT);
                        break;
                    case 27:
                        ACTIVE = false;
                        this.exitPopup(POPUP);
                        break;
                }
            }
        }

        let CANMOVE = true;

        document.ontouchmove = (e) => {
            if(CANMOVE && ACTIVE && handleTouchMove(e) === 2) {
                CANMOVE = false;
                CURNUM = this.goLeft(RIGHT, CURNUM, LEFT);
            } else if(CANMOVE && ACTIVE && handleTouchMove(e) === 1) {
                CANMOVE = false;
                CURNUM = this.goRight(RIGHT, CURNUM, LEFT)
            }
            setTimeout(() => {
                CANMOVE = true;
            }, 1000);
        }
        document.ontouchstart = (e) => {
            if(ACTIVE && CANMOVE) handleTouchStart(e)
        }

        $(LEFT).on('click', () => {
            CURNUM = this.goLeft(RIGHT, CURNUM, LEFT);
        });

        $(RIGHT).on('click', () => {
            CURNUM = this.goRight(RIGHT, CURNUM, LEFT);
        });

        $(POPUP).on('click',(e) => {
            if(e.target.id === 'popup' || e.target.id === 'exitpopup' ) {
                ACTIVE = false;
                this.exitPopup(POPUP);
            }
        });

        var xDown = null;
        var yDown = null;

        function getTouches(evt) {
            return evt.touches ||             // browser API
                evt.originalEvent.touches; // jQuery
        }

        function handleTouchStart(evt) {
            const firstTouch = getTouches(evt)[0];
            xDown = firstTouch.clientX;
            yDown = firstTouch.clientY;
        };

        function handleTouchMove(evt) {
            if ( ! xDown || ! yDown ) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;

            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
                if (xDiff > 0) {
                    return 1
                } else {
                    return 2
                }
            }

            xDown = null;
            yDown = null;
        };



    }

    exitPopup(POPUP){
        $(POPUP).css('display', 'none');
        $(POPUP).css('opacity', '0');
        $('.block.post').remove();
        $('.block.pre').remove();
    }

    goRight(RIGHT, CURNUM, LEFT) {
        if(!$(RIGHT).hasClass('noclick')) {
            CURNUM = CURNUM + 1;

            const rightElem = $('*[data-img="' + (CURNUM+1) + '"]');

            $('.block.pre').remove();
            $('.block.active').addClass('pre');
            $('.block.active').removeClass('active');
            $('.block.post').addClass('active');
            $('.block.post').removeClass('post');

            CURNUM = $('.block.active').data('num');

            if (rightElem.length) {
                $('<div class="block post" data-num="'+(CURNUM+1)+'"><img src="' + $(rightElem).attr('src') + '"/></div>').insertAfter($('.block.active'))
            } else {
                $(RIGHT).addClass('noclick')
            }
            $(LEFT).removeClass('noclick')
        }

        return CURNUM;
    }

    goLeft(RIGHT, CURNUM, LEFT) {
        if(!$(LEFT).hasClass('noclick')) {
            CURNUM = CURNUM - 1;
            const leftElem = $('*[data-img="' + (CURNUM - 1) + '"]');

            $('.block.post').remove();
            $('.block.active').addClass('post');
            $('.block.active').removeClass('active');
            $('.block.pre').addClass('active');
            $('.block.pre').removeClass('pre');

            if (leftElem.length) {
                $('<div class="block pre" data-num="'+(CURNUM-1)+'"><img src="' + $(leftElem).attr('src') + '"/></div>').insertBefore($('.block.active'))
            } else {
                $(LEFT).addClass('noclick')
            }
            $(RIGHT).removeClass('noclick')
        }
        return CURNUM;
    }
}